import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexBetween,
  FlexColCenter,
  FlexRowCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
  getRequestRowInfo,
  getAccountRowInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { getRequestIcon, getRequestColor } from '../../../utilities';
import { FormWrapper, FormInput } from '../Form/FormInput';
import { Button } from '../General/Button';
import { Title } from '../General/Title';
import { OutsideClick } from '../../Defaults/OutsideClick';
import { InfoText, InfoType } from '../General/InfoText';

export interface Props {
  state: { name: string; surname: string; email: string; password: string };
  onChange: (e) => void;
  theme: any;
  handleClose: any;
  handleAddAccount: any;
  error: any;
  isSaving: boolean;
}

function AddAccount({
  onChange,
  state: { name, surname, email, password },
  theme,
  handleClose,
  handleAddAccount,
  error,
  isSaving,
}: Props) {
  return (
    <AddAccountWrapper>
      <ModalStyle />
      <ModalHolder>
        <OutsideClickWrapper>
          <OutsideClick handleFunction={handleClose}>
            <Wrapper>
              <DimWrapper dimmed={isSaving}>
                <TitleWrapper>
                  <Title marginTop={0} marginBottom={0}>
                    {__('Pridať účet')}
                  </Title>
                  <SvgIcon
                    onClick={handleClose}
                    width={24}
                    height={24}
                    icon={IconType.close}
                    alt="Zavrieť okno"
                    title="Zavrieť okno"
                    fill={theme.colors.textPrimary}
                    cursor={'pointer'}
                  />
                </TitleWrapper>
                <FormWrapper maxWidth={592}>
                  <FormInput
                    name="name"
                    type="text"
                    label={__('Meno')}
                    value={name}
                    marginRight={16}
                    onChange={onChange}
                    required={true}
                    maxWidthPx={280}
                  />
                  <FormInput
                    name="surname"
                    type="text"
                    label={__('Priezvisko')}
                    value={surname}
                    onChange={onChange}
                    required={true}
                    maxWidthPx={280}
                  />
                </FormWrapper>
                <FormWrapper maxWidth={592}>
                  <FormInput
                    name="email"
                    type="text"
                    label={__('Email')}
                    value={email}
                    marginRight={16}
                    onChange={onChange}
                    required={true}
                    maxWidthPx={280}
                  />
                  <FormInput
                    name="password"
                    type="password"
                    label={__('Heslo')}
                    value={password}
                    onChange={onChange}
                    required={true}
                    maxWidthPx={280}
                  />
                </FormWrapper>
                {error && (
                  <InfoText
                    type={InfoType.ERROR}
                    info={`${__('Pri ukladaní sa vyskytla chyba')} - ${
                      error.description
                    }`}
                  />
                )}
                <AddButton onClick={handleAddAccount}>
                  {' '}
                  {isSaving ? __('Ukladám údaje ...') : __('Pridať')}
                </AddButton>
              </DimWrapper>
            </Wrapper>
          </OutsideClick>
        </OutsideClickWrapper>
      </ModalHolder>
    </AddAccountWrapper>
  );
}

const OutsideClickWrapper = styled.div`
  width: 100%;
  max-width: ${rem(656)};
`;

const DimWrapper = styled(FlexCol)<{ dimmed: boolean }>`
  opacity: ${({ dimmed }) => (dimmed ? 0.4 : 1)};
`;

const Wrapper = styled(FlexCol)`
  padding: ${rem(32)};
  width: 100%;
  position: relative;
  opacity: 1;
  background: white;
  border-radius: ${rem(4)};
  margin: ${rem(16)} auto;
  box-shadow: ${({ theme }) => theme.boxShadow.default};

  ${({ theme }) => theme.mediab.m580`
      padding: ${rem(24)};
      margin: ${rem(16)};
      width: initial;
  `};
`;

const AddAccountWrapper = styled.div``;

const TitleWrapper = styled(FlexRowCenter)`
  justify-content: space-between;
  margin-bottom: ${rem(32)};
`;

const AddButton = styled(Button)`
  height: ${rem(48)};
  padding: 0 ${rem(16)};
  width: 100%;
  max-width: ${rem(160)};
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  border-radius: ${rem(2)};
  margin: ${rem(16)} 0 0;

  &:disabled {
    background-color: #dcd6d6;
  }

  ${({ theme }) => theme.mediab.m580`
    max-width: initial;
    margin-top: ${rem(32)};
  `}
`;

const ModalHolder = styled(FlexColCenter)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.index.modal};
`;

const ModalStyle = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.2;
  z-index: ${({ theme }) => theme.index.modal};
`;

const WithThemeComponent: any = withTheme(AddAccount);
export { WithThemeComponent as AddAccount };
